import { Component, Inject } from "@angular/core";
import { FormBuilder, Validators, FormArray } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NotificationService } from "../../../../../../src/app/admin/services/notification.service";
import { ApiserviceService } from "../../../../../../src/app/apiservice.service";

@Component({
  selector: 'label-dialog',
  templateUrl: './label-dialog.html',
  styleUrls: ['../../master-assignment.component.css']
})

export class LabelDialog {
  language_valueset: Array<{}> = [];
  languages: Array<any>;
  labelValueForm: any;
  parent: any;
  constructor(public dialogRef: MatDialogRef<LabelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, private readonly api: ApiserviceService,
    private readonly _fb: FormBuilder, private readonly notify: NotificationService) {
    this.parent = this.data.parent;
    this.languages = this.api.language_list;
    this.labelValueForm = this._fb.group({
      language: this._fb.array([])
    })
    this.addRow();
    if (this.data.neigh_obj) {
      this.labelValueForm.patchValue({ 'language': [{ language: this.languages[0].language_id, value: this.data.neigh_obj.poly.label[this.api.language] }] });
    } else {
      this.labelValueForm.patchValue({ 'language': [{ language: this.languages[0].language_id, value: '' }] });
    }
  }
  addLabel(data, e) {
    let body = { label: {}, geom: null };
    let val = data.value
    val.language.forEach((v) => {
      body.label[v.language] = v.value;
    });
    let enlang = val.language.find(a=> a.language == 1);
    if(enlang){
    }else{
      this.notify.notify('English Label is required','warn');
      return;
    }
    body.geom = 'POLYGON((' + this.parent.polygon + '))';


    if (!this.data.neigh_obj) {
      let label = body.label[1].toLowerCase();
      let matched = (this.parent.polygons.find((e)=> e.label[1].toLowerCase() == label));
      if(matched){
        this.notify.notify('Geometry already exist with same name!','warn');
        return;
      }else{
        this.parent.polygons.push(body);
      }
    } else {
      let label = body.label[1].toLowerCase();
      let matched = (this.parent.polygons.find((e)=> e.label[1].toLowerCase() == label));
      if(matched){
      this.notify.notify('Geometry already exist with same name!', 'warn')
        return;
      }else{
        let ndata = this.data.neigh_obj.poly;
        ndata['label']=body.label;
        this.parent.polygons.push(ndata);
      }
    }
    this.parent.saveDialog(true);
    this.dialogRef.close();
  }
  initLanguageFields() {
    return this._fb.group({
      language: ['', Validators.required],
      value: ['', Validators.required]
    });
  }
  addRow() {
    if (this.language_valueset?.length == this.languages?.length) {
      this.notify.notify("No more Languages Available to Add", 'warn', 4000);
      return;
    }
    this.language_valueset.push({ language: '', value: '' });
    /* #Form */
    let dd = <FormArray>this.labelValueForm.controls.language;
    dd.push(this.initLanguageFields());
    /* End - #Form */
  }

  removeRow(key) {
    if (this.language_valueset.length > 1) {
      this.language_valueset.splice(key, 1);
      let dd = <FormArray>this.labelValueForm.controls.language;
      dd.removeAt(key);
    }
  }
  close() {
    this.parent.reset();
    this.parent.drawingManager.setDrawingMode(null);
    this.parent.drawingManager.setMap(this.parent.map);
    this.dialogRef.close();
  }
}
